// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2IC4I","inner":"Form_inner__1eo75","range":"Form_range__3WfBi","name":"Form_name__2tzXe","actions":"Form_actions__3QOsG"};